import Vue from 'vue'
import Router from 'vue-router'
const year = new Date().getFullYear()

const Home = () =>
	import('@/views/Home')
const About = () =>
	import('@/views/about')
const Fuwu = () =>
	import('@/views/privacy/fuwu')
const Yinsi = () =>
	import('@/views/privacy/yinsi')
Vue.use(Router)


export default new Router({
	base: '/flority/',
	mode: 'history',
	scrollBehavior(to, from, savedPosition) { // 跳转页面默认保持滚动顶部 (只在支持 history.pushState 的浏览器中可用。)
		return {
			x: 0,
			y: 0
		}
	},
	routes: [{
		path: '/',
		name: 'Home',
		component: Home,
		meta: {
			title: 'Flority: Digital Flower Art ' + year,
			description: 'Flority - Make Someone\'s Day Bloom',
			keywords: 'Flority, Digital Flower Art'
		}
	}, {
		path: '/about',
		name: 'About',
		component: About,
		meta: {
			title: 'About Flority: Digital Flower Art ' + year,
			description: 'Flority - Make Someone\'s Day Bloom',
			keywords: 'Flority, Digital Flower Art'
		}
	}, {
		path: '/service',
		name: 'Fuwu',
		component: Fuwu,
		meta: {
			title: 'Flority Terms of Use',
			description: 'Flority Terms of Use',
			keywords: 'Flority, Digital Flower Art'
		}
	}, {
		path: '/privacy',
		name: 'Yinsi',
		component: Yinsi,
		meta: {
			title: 'Flority Privacy Policy',
			description: 'Flority Privacy Policy',
			keywords: 'Flority, Digital Flower Art'
		}
	}, {
		path: '*',
		redirect: '/'
	}]
})
